import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookCheck, Loader2, Banknote } from "lucide-react";
import { Button } from "./ui/button";
import { api } from "../lib/api";

const fmt = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });

export const PayrollLedgerBar = ({ month, refresh }) => {
  const [d, setD] = useState(null), [busy, setBusy] = useState(""), [method, setMethod] = useState("bank");
  const load = () => month && api.payrollLedger(month).then(setD).catch(() => setD(null));
  useEffect(() => { load(); }, [month, refresh]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d?.linked || !d.published) return null;
  const run = async (kind) => {
    if (kind === "pay" && !window.confirm(`تأكيد صرف ${fmt(d.unpaid_net)} ر.س (${d.unpaid} موظف) ${method === "bank" ? "من البنك" : "من الصندوق"}؟`)) return;
    setBusy(kind);
    try {
      const r = kind === "pay" ? await api.payrollPay(month, method) : await api.payrollAccrue(month);
      toast.success(`تم إنشاء القيد ${r.journal_number}`); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر إنشاء القيد"); } finally { setBusy(""); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-indigo-200 bg-indigo-50 p-3 text-sm" data-testid="payroll-ledger-bar">
      <BookCheck className="h-4 w-4 text-indigo-600" />
      <span className="font-semibold text-indigo-900">القيود المحاسبية للرواتب:</span>
      {d.entries.map((e) => <span key={e.number} className="rounded-full bg-white px-2 py-0.5 text-xs text-indigo-700" data-testid={`payroll-je-${e.number}`}>{e.kind === "payment" ? "صرف" : "استحقاق"} {e.number} · {fmt(e.amount)}</span>)}
      <div className="ms-auto flex flex-wrap items-center gap-2">
        {d.unaccrued > 0 && <Button size="sm" variant="outline" disabled={!!busy} onClick={() => run("accrue")} data-testid="payroll-accrue-btn">{busy === "accrue" && <Loader2 className="h-4 w-4 animate-spin" />} ترحيل قيد الاستحقاق ({d.unaccrued})</Button>}
        {d.unpaid > 0 && <>
          <select value={method} onChange={(e) => setMethod(e.target.value)} className="h-8 rounded-lg border border-indigo-200 bg-white px-2 text-xs" data-testid="payroll-pay-method">
            <option value="bank">من البنك</option><option value="cash">من الصندوق</option>
          </select>
          <Button size="sm" disabled={!!busy} onClick={() => run("pay")} className="gap-1 bg-indigo-600 hover:bg-indigo-700" data-testid="payroll-pay-btn">{busy === "pay" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Banknote className="h-4 w-4" />} تم الصرف ({fmt(d.unpaid_net)})</Button>
        </>}
        {!d.unaccrued && !d.unpaid && <span className="text-xs text-emerald-700" data-testid="payroll-ledger-done">كل رواتب الشهر مرحّلة ومصروفة</span>}
      </div>
    </div>
  );
};
